import { resolveEntityPath } from "./resolveEntityPath";
import { getEntityTabLabel } from "./tabNavigation";

export function openEntityEditTab(
  tabNav,
  { entity, id, label, userRole, currentPathname }
) {
  if (entity === "quiz") {
    const base =
      resolveEntityPath("quiz", userRole, currentPathname) ??
      (currentPathname?.startsWith("/management")
        ? "/management/quiz"
        : "/operation/quiz");
    const pathname = `${base}/${id}/edit`;
    if (tabNav.enabled) {
      tabNav.open({ pathname, label: label ?? "Quiz" });
    } else {
      window.open(pathname, "_blank");
    }
    return;
  }

  const pathname = resolveEntityPath(entity, userRole, currentPathname);
  if (!pathname || !id) return;

  const tabLabel = label ?? getEntityTabLabel(null, id, entity);
  if (tabNav.enabled) {
    tabNav.openDetail({ pathname, id, mode: "edit", label: tabLabel });
  } else {
    window.open(`${pathname}?id=${id}&mode=edit`, "_blank");
  }
}
